import type { IconProps } from './icon.types'

const CheckIcon = (props: IconProps) => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.6'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='check-icon'
    {...props}
  >
    <path d='M1.5 5.3 4 7.7 8.5 2.5' />
  </svg>
)

export default CheckIcon
